import { motion } from "framer-motion";
import { PHASES } from "@/lib/lunelle-data";

const phaseOf = (day) => PHASES.find((p) => day >= p.days[0] && day <= p.days[1]);

export const CycleRing = ({ active, onSelect }) => {
  const days = Array.from({ length: 28 }, (_, i) => i + 1);
  const current = PHASES.find((p) => p.id === active);
  return (
    <div className="relative mx-auto aspect-square w-full max-w-[440px]" data-testid="cycle-ring">
      <svg viewBox="0 0 400 400" className="h-full w-full">
        <circle cx="200" cy="200" r="168" fill="none" stroke="#C86D51" strokeOpacity="0.15" strokeDasharray="2 6" />
        {days.map((d) => {
          const p = phaseOf(d);
          const a = ((d - 1) / 28) * Math.PI * 2 - Math.PI / 2;
          const on = p.id === active;
          return (
            <motion.circle key={d} cx={200 + Math.cos(a) * 150} cy={200 + Math.sin(a) * 150}
              animate={{ r: on ? 11 : 6, opacity: on ? 1 : 0.35 }} transition={{ type: "spring", stiffness: 200, damping: 18 }}
              fill={p.color} className="cursor-pointer" onClick={() => onSelect(p.id)} data-testid={`cycle-ring-day-${d}`} />
          );
        })}
      </svg>
      <div className="absolute inset-[22%] flex flex-col items-center justify-center rounded-full bg-[#FBF5EE] text-center shadow-[inset_0_0_0_1px_rgba(200,109,81,0.15)]">
        <motion.span key={current.id} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="flex flex-col items-center">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#7A665C]">Days {current.days[0]}–{current.days[1]}</span>
          <span className="mt-2 font-serif text-3xl text-[#2C221E] sm:text-4xl">{current.season}</span>
          <span className="mt-1 font-serif text-lg italic" style={{ color: current.color }}>{current.mood}</span>
        </motion.span>
      </div>
    </div>
  );
};
